import React, { useEffect, useRef, useState } from "react";
import TableContainer from '@/components/TableContainer';
import {
  Modal,
  Descriptions,
  Image as Image1,
  Table,
  Pagination,
  Checkbox,
  Popover,
  Select,
  Space,
  Flex,
  Button,
  Tooltip,
  Row,
  Col,
  Typography,
} from "antd";
import { DownloadOutlined, PrinterOutlined } from "@ant-design/icons";

import { useNavigate } from "react-router";
import { toast } from "react-toastify";
import {
  get_printer_list,
  generate_material_machine_print,
} from "../../utils/api";
import html2canvas from "html2canvas";

// Component and icon aliases for compatibility
const Stack = Space;
const Grid = ({ item, container, xs, lg, style, children, ...props }) => {
  if (container) {
    return <Row style={style} {...props}>{children}</Row>;
  }
  if (item) {
    return <Col xs={xs} lg={lg} style={style} {...props}>{children}</Col>;
  }
  return <div style={style} {...props}>{children}</div>;
};
const Paper = ({ ref, elevation, style, children, ...props }) => {
  return <div ref={ref} style={{ boxShadow: elevation ? '0 2px 8px rgba(0,0,0,0.15)' : 'none', ...style }} {...props}>{children}</div>;
};
const IconButton = Button;
const FileDownloadIcon = DownloadOutlined;
const LocalPrintshopIcon = PrinterOutlined;

function QrPrinter({
  set_show_qr,
  show_qr,
  set_qr_image,
  qr_image,
  componentRef,
  from,
  material_unit,
  material_id,
}) {
  const navigate = useNavigate();
  const [printerData, setPrinterData] = useState([]);
  const handleOk = () => {};
  const [selectedPrinter, setSelectedPrinter] = useState("");

  const printQrByIP = async (req) => {
    try {
      await generate_material_machine_print(req, success_print_qr);
    } catch (error) {
      console.log(error);
    }
  };

  const success_print_qr = (res) => {
    if (res?.status === "success") {
      toast?.success(res?.message);
      set_show_qr(!show_qr);
    } else {
      toast?.warning(res?.message);
    }
  };
  const getPrinterList = async () => {
    try {
      await get_printer_list(success_get_printer_list);
    } catch (error) {
      console.log(error);
    }
  };
  const success_get_printer_list = (res) => {
    setPrinterData(res?.data?.data);
  };

  const handleCancel = () => {
    set_show_qr(false);
    setSelectedPrinter("");
    set_qr_image();
  };

  useEffect(() => {
    getPrinterList();
  }, []);
  // -----------------pagination------------------------

  return (
    <>
      <Modal
        open={show_qr}
        title=""
        onOk={handleOk}
        onCancel={handleCancel}
        footer={[]}
      >
        <Stack
          direction="vertical"
          align="center"
          style={{ height: "100%", width: "100%" }}
        >
          {/* <Image1 style={{ width: "350px", height: "auto" }}  src={`data:image/png;base64,${qr_image}`} /> */}
          <Paper
            ref={componentRef}
            elevation={3}
            style={{ padding: "12px", maxWidth: "100%", margin: "auto" }}
          >
            <Grid container>
              {from !== "machine" ? (
                <>
                  <Grid
                    container
                    item
                    xs={7}
                    lg={7}
                    style={{ padding: "8px", maxWidth: "100%", margin: "auto" }}
                  >
                    <Grid item xs={7}>
                      <Typography.Text
                        style={{ fontSize: "clamp(0.7rem, 1.5vw, 1.1rem)" }}
                      >
                        <strong>Material No :</strong>
                      </Typography.Text>
                    </Grid>
                    <Grid item xs={5}>
                      <Typography.Text
                        style={{ fontSize: "clamp(0.7rem, 1.5vw, 1.1rem)" }}
                      >
                        {qr_image?.material_unique_id}
                      </Typography.Text>
                    </Grid>
                    <Grid item xs={7}>
                      <Typography.Text
                        style={{ fontSize: "clamp(0.7rem, 1.5vw, 1.1rem)" }}
                      >
                        <strong>Batch No :</strong>
                      </Typography.Text>
                    </Grid>
                    <Grid item xs={5}>
                      <Typography.Text
                        style={{ fontSize: "clamp(0.7rem, 1.5vw, 1.1rem)" }}
                      >
                        {qr_image?.lot_number}
                      </Typography.Text>
                    </Grid>
                    <Grid item xs={7}>
                      <Typography.Text
                        style={{ fontSize: "clamp(0.7rem, 1.5vw, 1.1rem)" }}
                      >
                        <strong>Mfg Date :</strong>
                      </Typography.Text>
                    </Grid>
                    <Grid item xs={5}>
                      <Typography.Text
                        style={{ fontSize: "clamp(0.7rem, 1.5vw, 1.1rem)" }}
                      >
                        {qr_image?.opening_date}
                      </Typography.Text>
                    </Grid>

                    <Grid item xs={7}>
                      <Typography.Text
                        style={{ fontSize: "clamp(0.7rem, 1.5vw, 1.1rem)" }}
                      >
                        <strong>Exp Date :</strong>
                      </Typography.Text>
                    </Grid>
                    <Grid item xs={5}>
                      <Typography.Text
                        style={{ fontSize: "clamp(0.7rem, 1.5vw, 1.1rem)" }}
                      >
                        {qr_image?.expiry_date}
                      </Typography.Text>
                    </Grid>
                    <Grid item xs={7}>
                      <Typography.Text
                        style={{ fontSize: "clamp(0.7rem, 1.5vw, 1.1rem)" }}
                      >
                        <strong>Pack Qty :</strong>
                      </Typography.Text>
                    </Grid>
                    <Grid item xs={5}>
                      <Typography.Text
                        style={{ fontSize: "clamp(0.7rem, 1.5vw, 1.1rem)" }}
                      >
                        {qr_image?.bag_size}
                      </Typography.Text>
                    </Grid>
                    <Grid item xs={7}>
                      <Typography.Text
                        style={{ fontSize: "clamp(0.7rem, 1.5vw, 1.1rem)" }}
                      >
                        <strong>Packs :</strong>
                      </Typography.Text>
                    </Grid>
                    <Grid item xs={5}>
                      <Typography.Text
                        style={{ fontSize: "clamp(0.7rem, 1.5vw, 1.1rem)" }}
                      >
                        {qr_image?.packs}
                      </Typography.Text>
                    </Grid>
                    <Grid item xs={7}>
                      <Typography.Text
                        style={{ fontSize: "clamp(0.7rem, 1.5vw, 1.1rem)" }}
                      >
                        <strong>Pack Status :</strong>
                      </Typography.Text>
                    </Grid>
                    <Grid item xs={5}>
                      <Typography.Text
                        style={{ fontSize: "clamp(0.7rem, 1.5vw, 1.1rem)" }}
                      >
                        {"R"}
                      </Typography.Text>
                    </Grid>
                  </Grid>
                </>
              ) : (
                <>
                  <Grid
                    container
                    item
                    xs={7}
                    lg={7}
                    style={{ padding: "8px", maxWidth: "100%", margin: "auto" }}
                  >
                    <Grid item xs={8}>
                      <Typography.Text
                        style={{ fontSize: "clamp(0.7rem, 1.5vw, 1.1rem)" }}
                      >
                        <strong>Machine Id :</strong>
                      </Typography.Text>
                    </Grid>
                    <Grid item xs={4}>
                      <Typography.Text
                        style={{ fontSize: "clamp(0.7rem, 1.5vw, 1.1rem)" }}
                      >
                        {qr_image?.machine_id}
                      </Typography.Text>
                    </Grid>
                    <Grid item xs={8}>
                      <Typography.Text
                        style={{ fontSize: "clamp(0.7rem, 1.5vw, 1.1rem)" }}
                      >
                        <strong>Name :</strong>
                      </Typography.Text>
                    </Grid>
                    <Grid item xs={4}>
                      <Typography.Text
                        style={{ fontSize: "clamp(0.7rem, 1.5vw, 1.1rem)" }}
                      >
                        {qr_image?.machine_name}
                      </Typography.Text>
                    </Grid>
                  </Grid>
                </>
              )}

              {/* Right Grid - QR Code Image */}
              <Grid item xs={5}>
                <img
                  src={`data:image/png;base64,${qr_image?.qr}`}
                  alt="QR Code"
                  style={{
                    width: "100%",
                    height: "auto",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                />
              </Grid>
            </Grid>
          </Paper>
          <Stack direction="horizontal" align="center">
            <Select
              allowClear
              showSearch
              id="demo-select-small"
              value={selectedPrinter || null}
              size="medium"
              style={{
                width: "180px",
                
                borderRadius: "3px",
              }}
              bordered
              placeholder="Select Printer"
              optionFilterProp="children"
              filterOption={(input, option) =>
                option.children.toLowerCase().includes(input.toLowerCase())
              }
              filterSort={(optionA, optionB) =>
                optionA.children.localeCompare(optionB.children)
              }
              dropdownStyle={{
                width: "250px",
                maxHeight: 400,
                overflow: "auto",
              }}
              onChange={(value, option) => {
                setSelectedPrinter(value);
              }}
            >
              {printerData?.map((item) => (
                <Select.Option key={item.machine_id} value={item.id}>
                  {`${item.machine_name}  [${item.room}]`}
                </Select.Option>
              ))}
            </Select>

            <Tooltip title="Print">
              <IconButton
                type="text"
                disabled={!selectedPrinter}
                icon={<LocalPrintshopIcon style={{ color: selectedPrinter ? "#1890ff" : undefined }} />}
                onClick={async () => {
                  if (from !== "machine") {
                    const req = {
                      machine_id: selectedPrinter,
                      qr_for: "material",
                      material_id: material_id,
                      unit: material_unit,
                      data: {
                        bag_size: qr_image?.bag_size,
                        lot_number: qr_image?.lot_number,
                        opening_date: qr_image?.opening_date,
                        expiry_date: qr_image?.expiry_date,
                        packs: qr_image?.packs,
                      },
                    };
                    printQrByIP(req);
                  } else {
                    const req = {
                      machine_id: selectedPrinter,
                      qr_for: "machine",
                      data: {
                        machine_id: qr_image?.machine_id,
                        machine_name: qr_image?.machine_name,
                        qr_number: qr_image?.qr_number,
                        assert_no: qr_image?.assert_no,
                        installation_date: qr_image?.installation_date,
                        machine_type: qr_image?.machine_type,
                      },
                    };
                    printQrByIP(req);
                    //     const scale = 3; // Adjust for higher resolution displays
                    //     const canvas = await html2canvas(componentRef.current, {
                    //       scale: scale,
                    //       useCORS: true,
                    //     });

                    //     const data = canvas.toDataURL("image/png");

                    //     const printWindow = window.open("", "_blank");
                    //     printWindow.document.write(`
                    //   <html>
                    //     <head>
                    //       <title>Print</title>
                    //       <style>
                    //         @media print {
                    //           @page {
                    //             margin: 0;
                    //           }
                    //           body {
                    //             margin: 0;
                    //             width: 100%;
                    //             height: 100vh;
                    //             display: flex;
                    //             justify-content: center;
                    //             align-items: center;
                    //             background-color: white;
                    //           }
                    //           img {
                    //             width: 100%;
                    //             height: auto;
                    //             display: block;
                    //           }
                    //         }
                    //       </style>
                    //     </head>
                    //     <body>
                    //       <img src="${data}" onload="window.print(); window.close();" />
                    //     </body>
                    //   </html>
                    // `);
                    //     printWindow.document.close();
                  }
                }}
              />
            </Tooltip>
            <Tooltip title="Download">
              <IconButton
                type="text"
                icon={<FileDownloadIcon style={{ color: "#1890ff" }} />}
                onClick={async () => {
                  const scale = 3; // Adjust for higher resolution displays
                  const canvas = await html2canvas(componentRef.current, {
                    scale: scale,
                    useCORS: true,
                  });
                  const data = canvas.toDataURL("image/png");
                  // Create an anchor element and trigger the download
                  const link = document.createElement("a");
                  link.href = data;
                  link.download = "image.png"; // The name of the downloaded file
                  link.click();
                }}
              />
            </Tooltip>
          </Stack>
        </Stack>
      </Modal>
    </>
  );
}

export default QrPrinter;
